import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import axios from "axios";
import { UserLeaveRequest, HEADERS, getDepId, getOrgId } from "../api";

function LeaveRequest() {
  const [dataview, setdataview] = useState([]);
  const [page, setPage] = useState(0); // Track the current page
  const [pageSize, setPageSize] = useState(5); // Track the page size

  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();
      const DepId = getDepId();
      try {
        const requestData = { org_id: OrgID, dept_id: DepId };
        const response = await axios.post(UserLeaveRequest, requestData, {
          headers: HEADERS,
        });
        if (response.data.response_code === "0000") {
          setdataview(response.data.data);
          console.log("res", response);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const tableData = dataview.map((datas) => {
    const getLeaveStatusLabel = (status) => {
      switch (status) {
        case 1:
          return "Pending";
        case 2:
          return "Approved";
        case 3:
          return "Rejected";
        default:
          return "Unknown";
      }
    };

    return {
      user_name: datas.user_name,
      leave_type: datas.leave_type,
      leave_type_name: datas.leave_type_name,
      from_date: datas.from_date,
      to_date: datas.to_date,
      end_date: datas.end_date,
      days_off: datas.days_off,
      leave_status: getLeaveStatusLabel(datas.leave_status),
      leave_approver: datas.leave_approver,
      department_name: datas.department_name,
    };
  });
  console.log(tableData);

  const tableColumns = [
    { accessorKey: "user_name", header: "Employee Name" },
    { accessorKey: "leave_type_name", header: "Leave Type" },
    { accessorKey: "from_date", header: "Begin Date" },
    { accessorKey: "to_date", header: "End Date" },
    { accessorKey: "days_off", header: "Days Off" },
    { accessorKey: "leave_status", header: "Leave Status" },
    { accessorKey: "leave_approver", header: "Approver Name" },
    { accessorKey: "department_name", header: "Department Name" },
  ];

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  return (
    <div className="row-container p-2">
      <span className="title mb-3">Leave Requests</span>
      <MantineReactTable
        columns={tableColumns}
        data={paginatedData}
        enableFullScreenToggle={false}
        mantineTableBodyCellProps={{
          style: {
            backgroundColor: "#C8E3EC60",
            color: "#505050",
            border: "0.5px solid #fff",
            padding: "10px",
          },
        }}
        mantineTableHeadCellProps={{
          style: {
            backgroundColor: "#2d7d9f",
            fontSize: "14px",
            fontWeight: 500,
            color: "#fff",
            border: "1px solid #fff",
          },
        }}
        mantineTableBodyRowProps={(row) => ({
          style: {
            backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
          },
        })}
        enablePagination={false}
        // enableColumnResizing
        enableColumnOrdering
        styles={{
          pagination: {
            display: "none", // Hides pagination and removes space
          },
        }}
      />
      <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
        <div className="d-flex align-items-center gap-2">
          <span style={{ fontSize: "14px" }}>Items per page:</span>
          <select
            className="form-select"
            style={{ width: "110px" }}
            value={pageSize}
            onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
          >
            <option value={5}>5 rows</option>
            <option value={10}>10 rows</option>
            <option value={20}>20 rows</option>
            <option value={50}>50 rows</option>
            <option value={100}>100 rows</option>
          </select>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <span style={{ fontSize: "14px" }}>
            {totalRows === 0
              ? "Showing 0 to 0 of 0 items"
              : `Showing ${startRow} - ${endRow} of ${totalRows} items`}
          </span>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-3">
          <button
            className="previous-button"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 0}
          >
            Previous
          </button>
          <button
            className="add-button text-center justify-content-center"
            style={{ width: "100px" }}
            onClick={() => handlePageChange(page + 1)}
            disabled={(page + 1) * pageSize >= tableData.length}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeaveRequest;
